<template>
<w-sliding-popup ref="slidingPopup" type="full" :title="selectTitle" @close="closePopup">
  <div slot="content">
    <div class="condition-box mr-b25">
      <span class="mr-r4">기간선택</span>
      <el-date-picker style="width: 225px;" :editable="false" type="daterange" v-model="dateRange" format="yyyy-MM-dd" :clearable="false"
      :range-separator="defaultDateRangeOptions.rangeSeparator" :start-placeholder="defaultDateRangeOptions.startPlaceholder" :defaultTime="defaultDateRangeOptions.defaultTime"
      :end-placeholder="defaultDateRangeOptions.endPlaceholder" :picker-options="defaultDateRangeOptions.pickerOptions" />
      <div class="fl-r mr-t2">
        <ul class="diff-legend-box">
          <li><span class="item added"></span>추가</li>
          <li><span class="item modified"></span>변경</li>
          <li><span class="item deleted"></span>삭제</li>
        </ul>
        <el-radio-group class="ordinary cmp-margin-left" v-model="totalDataFlag">
          <el-radio-button :label="false">변경내역만 보기</el-radio-button>
          <el-radio-button :label="true">전체 보기</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="title-bar" type="flex">
      <div class="vertical-center-box" style="width:calc(50% - 15px);">
        <span class="title-h4 dot-title mr-r10">기준 이력</span>
        <el-select v-model="selectedHistSeq" placeholder="변경 이력 선택" @change="changeDate">
          <el-option v-for="changeInfo in changeInfoList" :key="changeInfo.seqNumber" :label="convertCheckDatetime(changeInfo.checkDatetime)" :value="changeInfo.seqNumber"></el-option>
        </el-select>
      </div>
      <div class="mr-l15" style="width:50%;">
        <el-row type="flex" justify="space-between">
          <div class="vertical-center-box">
            <span class="title-h4 dot-title mr-r10">비교대상 이력</span>
            <el-select v-model="comparedHistSeq" placeholder="변경 이력 선택" @change="changeDate">
              <el-option v-for="changeInfo in changeInfoList" :key="changeInfo.seqNumber" :label="convertCheckDatetime(changeInfo.checkDatetime)" :value="changeInfo.seqNumber"></el-option>
            </el-select>
          </div>
        </el-row>
      </div>
    </div>
    <el-row type="flex">
      <div class="vertical-center-box" style="width:calc(50% - 15px);">
        <el-table :data="selectedFilteredData" style="width: 100%" :row-class-name="tableRowClassName">
          <el-table-column prop="type" label="변경">
            <template slot-scope="scope">
              {{ getChangeTypeName(scope.row.type) }}
            </template>
          </el-table-column>
          <el-table-column prop="apName" label="AP 이름"></el-table-column>
          <el-table-column prop="ipAddress" label="IP"></el-table-column>
          <el-table-column prop="macAddress" label="MAC"></el-table-column>
        </el-table>
      </div>
      <div class="mr-l15" style="width:50%;">
        <el-table :data="compareFilteredData" style="width: 100%" :row-class-name="tableRowClassName">
          <el-table-column prop="type" label="변경">
            <template slot-scope="scope">
              {{ getChangeTypeName(scope.row.type) }}
            </template>
          </el-table-column>
          <el-table-column prop="apName" label="AP 이름"></el-table-column>
          <el-table-column prop="ipAddress" label="IP"></el-table-column>
          <el-table-column prop="macAddress" label="MAC"></el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</w-sliding-popup>
</template>
<script>

import MsgUtil from '@/utils/message';
import { mapGetters } from 'vuex';
import { clone, find, indexOf, isNil, filter } from 'lodash';
import { getDateToString, defaultDateRangeOptions } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import wirelessDeviceInfoAPI from '@/api/config/wireless-device/wireless-device-info';

export default {
  name: 'WApControllerChangeHistPopup',
  props: {
    selectHistParams: Object,
  },
  data() {
    return {
      selectTitle: '',
      selectedHistSeq: null,
      comparedHistSeq: null,
      totalDataFlag: true,
      changeInfoList: [],
      dateRange: [],
      params: {
        objId: null,
        typeKey: null,
      },
      selectedTableData: null,
      selectedFilteredData: null,
      compareTableData: null,
      compareFilteredData: null,
      defaultDateRangeOptions,
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
  },
  watch: {
    selectHistParams: {
      handler() {
        this.params.objId = this.selectHistParams.objId;
        this.params.typeKey = this.selectHistParams.typeKey;
        this.selectTitle = `${this.selectHistParams.typeName} (${getDateToString(this.selectHistParams.checkDatetime)})`;
        this.dateRange = clone(this.selectHistParams.dateRange);
      },
    },
    dateRange: {
      handler() {
        this.loadData();
      },
    },
    totalDataFlag: {
      handler() {
        this.filterData();
      },
    },
  },
  methods: {
    /**
     * 팝업 open 핸들러
     * @author Hunui
     * @return {[type]} [description]
     */
    open() {
      this.$refs.slidingPopup.visible = true;
    },
    /**
     * 팝업 close 핸들러
     * @author Hunui
     * @return {[type]} [description]
     */
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 팝업 오픈 시 AP 구성변경 날짜 이력 조회
     * @author Hunui
     * @return {[type]} [description]
     */
    loadData() {
      if (this.selectHistParams.typeKey !== 'WIRELESS_AP_CONFIG') return;
      const loadParams = {
        ...this.params,
        startDatetime: this.dateRange[0].getTime(),
        endDatetime: this.dateRange[1].getTime(),
      };
      const action = MsgUtil.action.VIEW;
      const target = '무선 AP 구성변경 날짜';
      wirelessDeviceInfoAPI.getApConfigChangeHistDate(loadParams).then((response) => {
        if (response.data.success) {
          this.changeInfoList = response.data.data;
          this.setDataRange();
        } else {
          this.$message(MsgUtil.getResultMsgData(action, target, false));
        }
      }).catch((e) => {
        this.$message(MsgUtil.getResultMsgData(action, target, false));
        throw new Error(e);
      });
    },
    /**
     * 상세보기 버튼을 클릭한 row 에 맞는 chngGrpSeqNumber 의 데이터 선택
     * @author Hunui
     */
    setDataRange() {
      if (this.changeInfoList.length > 0) {
        const selected = find(this.changeInfoList, (o) => this.selectHistParams.chngGrpSeqNumber === o.chngGrpSeqNumber);
        const index = indexOf(this.changeInfoList, selected);

        this.comparedHistSeq = this.changeInfoList[index].seqNumber;
        if (!isNil(this.changeInfoList[index + 1])) {
          this.selectedHistSeq = this.changeInfoList[index + 1].seqNumber;
        } else {
          this.selectedHistSeq = this.changeInfoList[index].seqNumber;
        }
        this.changeDate();
      } else {
        this.changeInfoList = [];
        this.comparedHistSeq = null;
        this.selectedHistSeq = null;
        this.selectedTableData = null;
        this.compareTableData = null;
        this.selectedFilteredData = null;
        this.compareFilteredData = null;
      }
    },
    /**
     * 날짜 변경 시 데이터 조회
     * @author Hunui
     * @return {[type]} [description]
     */
    changeDate() {
      const loadParams = {
        ...this.params,
        histSeqList: this.selectedHistSeq === this.comparedHistSeq ? [this.selectedHistSeq] : [this.selectedHistSeq, this.comparedHistSeq],
      };
      const action = MsgUtil.action.VIEW;
      const target = '무선 AP 구성변경 비교이력';
      wirelessDeviceInfoAPI.compareApConfigHist(loadParams).then((response) => {
        if (response.data.success) {
          if (!isNil(response.data.data)) {
            this.selectedTableData = response.data.data.base;
            this.compareTableData = response.data.data.compare;
          } else {
            this.selectedTableData = null;
            this.compareTableData = null;
          }
          this.filterData();
        } else {
          this.$message(MsgUtil.getResultMsgData(action, target, false));
        }
      }).catch((e) => {
        this.$message(MsgUtil.getResultMsgData(action, target, false));
        throw new Error(e);
      });
    },
    /**
     * 정보 제공 타입에 따른 데이터 가공
     * @author Hunui
     * @return {[type]} [description]
     */
    filterData() {
      const filtering = (o) => o.type !== 'none';
      if (!this.totalDataFlag) {
        this.selectedFilteredData = filter(this.selectedTableData, filtering);
        this.compareFilteredData = filter(this.compareTableData, filtering);
      } else {
        this.selectedFilteredData = this.selectedTableData;
        this.compareFilteredData = this.compareTableData;
      }
    },
    /**
     * 날짜 형식 fomatter
     * @author Hunui
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    convertCheckDatetime(value) {
      return getDateToString(value);
    },
    /**
     * 테이블 row 의 타입에 따른 클래스 반환
     * @author Hunui
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    tableRowClassName({ row }) {
      return `${row.type}Row`;
    },
    /**
     * 변경 타입 KEY 기준으로 변경 타입 정보를 반환한다.
     * @author Ju
     * @param  {String} type
     * @return {String}
     */
    getChangeTypeName(type) {
      if (type === 'added') {
        return '추가';
      } else if (type === 'modified') {
        return '수정';
      } else if (type === 'deleted') {
        return '삭제';
      }
      return EMPTY_TEXT;
    },
  },
};
</script>

<style>
.addedRow {
  background-color: rgba(251, 134, 55, 0.4) !important;
}
.modifiedRow {
  background-color: rgba(115, 83, 255, 0.4) !important;
}
.deletedRow {
  background-color: rgba(102, 102, 102, 0.4) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/components/ApControllerChangeHistPopup.vue